"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageEpics = exports.updateMessageEpic = exports.selectTemplateEpic = exports.backToEditMessageEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _ramda = require("ramda");

var _gift = require("../../gift.types");

var _gift2 = require("../../gift.selector");

var _constants = require("../../../../constants");

var _message = require("./message.selectors");

var actions = _interopRequireWildcard(require("./message.actions"));

// TODO: Remove it when gift reducer will be split
var backToEditMessageEpic = function backToEditMessageEpic(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_EDIT_STEP), (0, _operators.filter)(function (_ref) {
    var payload = _ref.payload;
    return payload === _constants.steps.EDIT_TEMPLATE_MESSAGE;
  }), (0, _operators.map)(function () {
    return actions.setMessageDraft();
  }));
};

exports.backToEditMessageEpic = backToEditMessageEpic;

var selectTemplateEpic = function selectTemplateEpic(action$, state$) {
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_SELECT_TEMPLATE), (0, _operators.withLatestFrom)(state$.pipe((0, _operators.map)((0, _ramda.applySpec)({
    previewUrl: _gift2.getGiftLandingPage,
    textCharsLimit: (0, _ramda.compose)((0, _ramda.prop)('chars_limit'), _gift2.getGiftInvitationItem)
  })))), (0, _operators.map)(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        payload = _ref3[0].payload,
        _ref3$ = _ref3[1],
        previewUrl = _ref3$.previewUrl,
        textCharsLimit = _ref3$.textCharsLimit;

    var _ref4 = payload || {},
        _ref4$subject = _ref4.subject,
        subject = _ref4$subject === void 0 ? '' : _ref4$subject,
        _ref4$message = _ref4.message,
        text = _ref4$message === void 0 ? '' : _ref4$message,
        _ref4$name = _ref4.name,
        templateName = _ref4$name === void 0 ? '' : _ref4$name,
        _ref4$template_id = _ref4.template_id,
        templateId = _ref4$template_id === void 0 ? null : _ref4$template_id;

    return actions.setTemplateMessage({
      subject,
      shadowSubject: '',
      previewUrl,
      textCharsLimit,
      text,
      shadowText: '',
      isSaved: true,
      isDraft: true,
      templateName,
      templateId
    });
  }));
};

exports.selectTemplateEpic = selectTemplateEpic;

var updateMessageEpic = function updateMessageEpic(action$, state$, _ref5) {
  var createGiftService = _ref5.createGiftService,
      messagesService = _ref5.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(actions.updateMessage), (0, _operators.withLatestFrom)(state$.pipe((0, _operators.map)((0, _ramda.applySpec)({
    text: _message.getMessageText,
    subject: _message.getMessageSubject,
    emailProvider: _gift2.getGiftEmailProvider,
    templateId: _message.getTemplateId
  })))), (0, _operators.mergeMap)(function (_ref6) {
    var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
        _ref7$ = _ref7[0],
        isDraft = _ref7$.payload.isDraft,
        _ref7$$meta = _ref7$.meta,
        giftId = _ref7$$meta.giftId,
        previewUrl = _ref7$$meta.previewUrl,
        sidebarMode = _ref7$$meta.sidebarMode,
        _ref7$2 = _ref7[1],
        text = _ref7$2.text,
        subject = _ref7$2.subject,
        emailProvider = _ref7$2.emailProvider,
        templateId = _ref7$2.templateId;

    return createGiftService.setGiftMessage({
      giftId,
      message: text,
      subject,
      isReadyToBeSend: !isDraft,
      templateId
    }).pipe((0, _operators.mergeMap)(function () {
      return sidebarMode ? [actions.updateMessageSuccess()] : [actions.updateMessageSuccess(), actions.openCustomPreview({
        emailProviderId: emailProvider.id,
        giftId
      })];
    }), (0, _operators.tap)(function () {
      if (previewUrl && sidebarMode) {
        window.open(previewUrl, '__blank');
      }
    }), (0, _operators.catchError)(messagesService.errorHandler({
      actions: actions.updateMessageFail,
      showErrorsAsGlobal: true
    })), (0, _operators.takeUntil)(action$.ofType(actions.updateMessage)));
  }));
};

exports.updateMessageEpic = updateMessageEpic;
var messageEpics = [selectTemplateEpic, updateMessageEpic, backToEditMessageEpic];
exports.messageEpics = messageEpics;